
























































































































































import { Component, mixins, namespace, Prop } from 'nuxt-property-decorator'
import { mdiHeartOutline, mdiHeart, mdiGiftOutline } from '@mdi/js'
import LazyHydrate from 'vue-lazy-hydration'
import { IProduct, IProductToFavourites } from '~/assets/interfaces/products'
import { IFavouriteItem } from '~/assets/interfaces/favourites'
import { filterLinkToProductReviews } from '~/assets/filters/produts'
import MixinGeneral from '~/assets/mixins/general'
import { filterBonus } from '~/assets/filters/bonus'
import { IStyle } from '~/assets/interfaces/classes'

const favouritesStore = namespace('favourites')
const siteStore = namespace('site')

@Component({
  filters: {
    filterLinkToProductReviews,
    filterBonus,
  },
  components: {
    ComponentIcon: () => import('~/components/icon/icon.vue'),
    ComponentProductAvailable: () =>
      import('~/components/products/product-available.vue'),
    LazyHydrate,
    ComponentProductBuyButton: () =>
      import('~/components/products/product-buy-button.vue'),
    ComponentImage: () => import('~/components/images/image.vue'),
    ComponentFormButton: () => import('~/components/form/button.vue'),
    ComponentRating: () => import('~/components/rating/rating.vue'),
    ComponentFormButtonIcon: () => import('~/components/form/button-icon.vue'),
    ComponentCatalogLabels: () =>
      import('~/components/catalog/labels/labels.vue'),
    ComponentProductAspects: () =>
      import('~/components/products/product-aspects.vue'),
    ComponentProductFeature: () =>
      import('~/components/products/product-feature.vue'),
    ComponentProductMoreDetailsLink: () =>
      import('~/components/products/product-more-details-link.vue'),
    ComponentProductDetailPricesLight: () =>
      import('~/components/products/product-detail-prices-light.vue'),
    ComponentAddToCompareIconButton: () =>
      import('~/components/products/product-add-to-compare-icon-button.vue'),
  },
})
export default class ComponentProductItem3 extends mixins(MixinGeneral) {
  private mdiHeartOutline = mdiHeartOutline
  private mdiHeart = mdiHeart
  private mdiGiftOutline = mdiGiftOutline
  @Prop({
    type: Object,
    default: () => {},
  })
  private item!: IProduct

  @Prop({
    type: Boolean,
    default: false,
  })
  private favourite!: boolean

  @favouritesStore.Action('toFavourites') private toFavourites!: (
    product: IProductToFavourites
  ) => Promise<void>

  @favouritesStore.State('items') private favouritesItems!: IFavouriteItem[]

  @siteStore.Getter('getOptionsProductShadow')
  private getOptionsProductShadow!: boolean

  private imageNumber = 0

  private get imagesAmount() {
    return this.item.images ? this.item.images.length : 0
  }

  private hover(num: number) {
    this.isHiddenImageLazyLoad = true
    this.imageNumber = num - 1
  }

  private mounted(): void {
    this.$emit('loaded')
  }

  private get isInFavourites() {
    return !!this.favouritesItems.find((item) => {
      return item.id === this.item.id
    })
  }

  private isLoading = false

  private isLoadingFavourites = false
  private async addToFavourites() {
    const tempProd = {
      id: this.item.id,
    }

    this.isLoadingFavourites = true
    await this.toFavourites(tempProd)
    this.isLoadingFavourites = false
  }

  private isHiddenImageLazyLoad = false
  private get styleImage() {
    let temp = {}
    if (this.item.ratio) {
      temp = Object.assign(temp,{    paddingTop: ((1 / eval(this.item.ratio)) * 100).toString() + '%', // eslint-disable-line
      })
    }

    if (this.item.imageLazyLoad && !this.isHiddenImageLazyLoad) {
      temp = Object.assign(temp, {
        backgroundImage: `url("${this.item.imageLazyLoad}")`,
      })
    }
    return temp
  }

  private get classWrapper() {
    return {
      [this.$style.product]: true,
      [this.$style.disable]: !this.item.inStock,
      [this.$style.trafaret]: this.item.trafaret,
      [this.$style.shadow]: this.getOptionsProductShadow,
      ...this.classDevice(this.$style),
    }
  }

  private styleSpacer!: IStyle
  private classImageWrapper = [this.$style.imageWrapper, this.styleSpacer.mb8]

  private get classVendorCode() {
    return [
      this.$style.vendorCode,
      this.classDevice(this.$style),
      this.styleSpacer.mb4,
    ]
  }

  private get classTitle() {
    return [this.$style.title, this.classDevice(this.$style)]
  }

  private get classRating() {
    return [this.$style.rating, this.classDevice(this.$style)]
  }

  private classFeatures = [this.$style.features, this.styleSpacer.mb12]

  private get classBuy() {
    return [this.$style.buy, this.classDevice(this.$style)]
  }

  private get classToFavouriteButton() {
    return {
      [this.$style.toFavouriteButton]: true,
      [this.$style.active]: this.isInFavourites,
    }
  }

  get imageAlt() {
    if (this.imageNumber !== 0 || !this.item.imageMeta) {
      return null
    }

    if (this.item.imageMeta.alt) {
      return this.item.imageMeta.alt
    }
    return null
  }

  get imageTitle() {
    if (this.imageNumber !== 0 || !this.item.imageMeta) {
      return null
    }

    if (this.item.imageMeta.title) {
      return this.item.imageMeta.title
    }
    return null
  }
}
